import { useContext } from "react";
import { Outlet } from "react-router-dom";
// import Menu from "../components/Menu/Menu";
import { Context } from "../context/context";

// {id: 1, name: "Administrador"}

// {id: 2, name: "Supervisor"}

// {id: 3, name: "Vendedor"}

// {id: 4, name: "RH"}

// {id: 5, name: "Vendedor Externo"}

// {id: 6, name: "Vendedor Interno"}

export default function PrivateRoles({ permission }) {
  const { sidebar } = useContext(Context);

  const role = JSON.parse(localStorage.getItem("role"));
  let isPermitted = false;

  if (Array.isArray(permission)) {
    isPermitted = permission.some((el) => el === role);
  }

  return permission === role || isPermitted ? (
    <>
      <Outlet />
    </>
  ) : (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <h1>Permissão negada.</h1>
      </main>
    </>
  );
}
